import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Formik} from 'formik';
import Step6View from './Step6-view';
import {checkRequiredValues} from '../../utils/forms/checkRequiredValues';
import {getFileFromDataURI} from '../../utils/files/getFileFromDataURI';
import {fileTypesIds} from '../../constants/fileTypeIds';
import types from '../../types';
import {checkNextStepAndGo} from '../../utils/checkNextStepAndGo';
import {useIntl} from "react-intl";
import {trackEvent} from "../../utils/trackEvent";

const totalAgreementsCount = 25;

const Step6 = ({
                 submitStep,
                 uploadFile,
                 regType,
                 payload,
                 prevCompletedStepSign,
                 prevCompletedStepSignFalse,
               }) => {
  const [agreementsCount, setAgreementsCount] = useState(4);

  const checkAndIncreaseAgreementsCount = () => {
    if (agreementsCount < totalAgreementsCount) {
      setAgreementsCount(prevCount => {
        const newCount = prevCount + 4;
        return (newCount > totalAgreementsCount) ? totalAgreementsCount : newCount;
      });

      return false;
    }

    return true;
  };

  const getAgreements = () => {
    return new Array(agreementsCount).fill(' ').map((_, index) => `step6.form.agreements.p${index + 1}.label`)
  };

  const {percentValue, ...restPayload} = payload;

  const initialValues = {
    signDate: new Date(),
    firstName: '',
    lastName: '',
    idNumber: '',
    signature: null,
    approve: false,
    approveAdvertisement: false,
    approvePension: false,
    approveInsurance: false,
    ...restPayload
  };

  const validate = values => {
    if (agreementsCount < totalAgreementsCount) return {};

    const {signature, approve} = values;
    const requiredValues = {signature, approve};
    let errors = {};
    errors = checkRequiredValues(requiredValues, errors);

    return errors;
  };

  const handleSubmit = values => {
    if (checkAndIncreaseAgreementsCount()) {
      submit(values);
    }
  };

  const {formatMessage} = useIntl();

  const submit = values => {
    const {approveAdvertisement, approvePension, approveInsurance, signature} = values;
    getFileFromDataURI({dataURI: signature, filename: 'signature-contract.png'})
      .then(file => uploadFile({
        file,
        fileTypeId: fileTypesIds.step6.signature
      }))
      .then(() => submitStep({
        step: 6,
        data: {
          regType,
          approveAdvertisement,
          approvePension,
          approveInsurance,
          prevCompletedStepSign
        },
      }))
      .then(checkNextStepAndGo)
      .then(() => prevCompletedStepSignFalse())
      .then(() => trackEvent('signup_step',
          {
            step_number: 6,
            step_name_en: 'Contract agreement',
            step_name_he: formatMessage({id: 'step6.page.title', defaultMessage: ''}),
            regType
          }
        )
      )
      .catch(err => console.error({err}));
  };

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      onSubmit={handleSubmit}
      validate={validate}
      validateOnChange={true}
      validateOnBlur={false}
    >
      {({isValid, submitCount}) => (
        <Step6View
          agreements={getAgreements()}
          totalAgreementsCount={totalAgreementsCount}
          deliveryValue={percentValue}
          isValid={isValid || submitCount === 0}
        />
      )}
    </Formik>
  )
};

Step6.propTypes = {
  ...types.router,
  regType: PropTypes.string,
  submitStep: PropTypes.func,
  uploadFile: PropTypes.func,
  payload: PropTypes.object,
};

export default Step6;
